import { createFileRoute } from "@tanstack/react-router";
import { AppHeader } from "@/components/wb/AppHeader";
import { Batches } from "@/fla/Batches";

export const Route = createFileRoute("/_app/fla/batches/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <AppHeader names={[{ name: "All Batches" }]} />
      <Batches />
    </>
  );
}
